/** The call panel's width, in theme size steps (`theme.getSize`). */
export const CALL_PANEL_WIDTH = 95;
